export default "__VITE_ASSET__DTbgRtYV__"